import { iOffering } from "store/types/billingPricing";
import { eColor, tOfferingType } from "components/types";
import Popularity from '../assets/icons/popularity.svg';
import { iPricing } from "store/types/billingPricing";
import { eProductKey } from "store/types/subscriptionOrder";

interface iOfferingSettings {
  addOnDatabaseKey?: eProductKey,
  i18nPrefix: string,
  labelColor: string,
  labelIcon?: string,
  pricing?: iPricing,
  isElevated?: boolean,
  isFeaturesMultipleColumns?: boolean,
  isActionDisabled?: boolean,
  actionColor?: eColor,
  actionFunction?: () => void,
}

export const fallbackFunctionForUpgradeScenario = () => window && window
  .open(`https://share-eu1.hsforms.com/18y3Y42pRSZKENQ3xPp8H4Afaf1j`, '_blank')
  ?.focus()

export const developerFunction = () => window && window
  .open(`https://share-eu1.hsforms.com/10ly5Yf6yRPuOljlGmC72iwfaf1j`, `_blank`)
  ?.focus()

const settings: {[key: string]: {[key: string]: iOfferingSettings }} = {
  generic: {
    flex: {
      i18nPrefix: "offerings.generic.flex.",
      labelColor: '#A9EC62',
      isActionDisabled: true
    },
    education: {
      i18nPrefix: "offerings.generic.education.",
      labelColor: '#A9EC62',
      isActionDisabled: true
    },
    enterprise: {
      i18nPrefix: "offerings.generic.enterprise.",
      labelColor: '#A9EC62',
      isActionDisabled: true
    }
  },
  commercials: {
    essentials: {
      i18nPrefix: "offerings.commercials.essentials.",
      labelColor: '#A9EC62',
      pricing: {
        annualPrice: 3250,
        monthlyPrice: 24
      },
      actionColor: eColor.secondary,
      actionFunction: developerFunction
    },
    standard: {
      i18nPrefix: "offerings.commercials.standard.",
      labelColor: '#63CF00',
      pricing: {
        annualPrice: 4600,
      },
      actionColor: eColor.secondary,
      actionFunction: developerFunction
    },
    pro: {
      i18nPrefix: "offerings.commercials.pro.",
      labelColor: '#1B6600',
      pricing: {
        annualPrice: 4200,
      },
      isElevated: true,
      labelIcon: Popularity,
      actionColor: eColor.primary,
      actionFunction: developerFunction
    },
  },
}

const buildOffering = (settings: iOfferingSettings): iOffering => {

  const prefix = settings.i18nPrefix;

  return {
    addOnDatabaseKey: settings?.addOnDatabaseKey,
    label: prefix + "label",
    labelColor: settings.labelColor,
    labelIcon: settings.labelIcon,
    isElevated: settings.isElevated,
    price: {
      prefix: prefix + "price.prefix",
      suffix: prefix + "price.suffix",
      pricing: settings.pricing
    },
    isFeaturesMultipleColumns: settings.isFeaturesMultipleColumns || false,
    descriptionHeading: prefix + "descriptionHeading",
    description: prefix + "description",
    features: prefix + "features",
    action: prefix + "action",
    isActionDisabled: settings.isActionDisabled || false,
    actionColor: settings.actionColor,
    actionFunction: settings.actionFunction
  }
}

export const getOfferingsByType = (type: tOfferingType): iOffering[] => {
  let offerings: iOffering[] = []

  for (const p of Object.values(settings[type])) {
    const offering = buildOffering(p)
    offerings.push(offering)
  }

  return offerings
}